export const ValueFieldProp = Object.freeze({
    FieldType: 'fieldType',
    DataType: 'dataType',
    Value: 'value',
    Options: 'options',
});
